import * as React from 'react';
import { Tabs } from 'antd';
import { Badge } from 'components';
import styled from 'styled-components';

interface VirtualTourTabProps {
  setCurrentStep: (stepNumber: number) => void;
  updateState: (draft: any) => void;
  isMobile: boolean;
  hasVSFeatureFlag: boolean;
}
type showingTypes = 'inPersonShowing' | 'virtualShowing';

const VirtualTourTab: React.FC<VirtualTourTabProps> = ({
  updateState,
  setCurrentStep,
  isMobile,
  hasVSFeatureFlag,
}) => {
  const { TabPane } = Tabs;
  const changeHandler = (key: showingTypes) => {
    if (isMobile) {
      setCurrentStep(1);
    }
    updateState((draft: any) => {
      draft.isBookingVirtualTour = key === 'virtualShowing';
    });
  };
  const virtualTab = (
    <div data-cy="tab-virtual-showing">
      3D Virtual Showing{' '}
      <StyledSpan>
        <Badge count="new" />
      </StyledSpan>
    </div>
  );
  return (
    <div>
      <Tabs
        tabBarStyle={{ width: '97%', margin: 'auto' }}
        onChange={(key: showingTypes) => changeHandler(key)}
      >
        <TabPane tab="In Person Showing" key="inPersonShowing" />
        {hasVSFeatureFlag && <TabPane tab={virtualTab} key="virtualShowing" />}
      </Tabs>
      <br />
    </div>
  );
};

export default VirtualTourTab;

const StyledSpan = styled.span`
  padding-left: 5px;
`;
